/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Style_Guide_Manager_Enable_Guide_AriaInputs */

const en_style_guide_manager_enable_guide_aria = /** @type {(inputs: Style_Guide_Manager_Enable_Guide_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Enable ${i?.name}`)
};

const fr_style_guide_manager_enable_guide_aria = /** @type {(inputs: Style_Guide_Manager_Enable_Guide_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Activer ${i?.name}`)
};

const de_style_guide_manager_enable_guide_aria = /** @type {(inputs: Style_Guide_Manager_Enable_Guide_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} aktivieren`)
};

const it_style_guide_manager_enable_guide_aria = /** @type {(inputs: Style_Guide_Manager_Enable_Guide_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Abilita ${i?.name}`)
};

const ru_style_guide_manager_enable_guide_aria = /** @type {(inputs: Style_Guide_Manager_Enable_Guide_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Включить ${i?.name}`)
};

const es_style_guide_manager_enable_guide_aria = /** @type {(inputs: Style_Guide_Manager_Enable_Guide_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Habilitar ${i?.name}`)
};

const zh_cn2_style_guide_manager_enable_guide_aria = /** @type {(inputs: Style_Guide_Manager_Enable_Guide_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`启用${i?.name}`)
};

const ja_style_guide_manager_enable_guide_aria = /** @type {(inputs: Style_Guide_Manager_Enable_Guide_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} を有効にする`)
};

const hi_style_guide_manager_enable_guide_aria = /** @type {(inputs: Style_Guide_Manager_Enable_Guide_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} को सक्षम करें`)
};

const pt_pt2_style_guide_manager_enable_guide_aria = /** @type {(inputs: Style_Guide_Manager_Enable_Guide_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ativar ${i?.name}`)
};

/**
* | output |
* | --- |
* | "Enable {name}" |
*
* @param {Style_Guide_Manager_Enable_Guide_AriaInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_manager_enable_guide_aria = /** @type {((inputs: Style_Guide_Manager_Enable_Guide_AriaInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Manager_Enable_Guide_AriaInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_style_guide_manager_enable_guide_aria(inputs)
	if (locale === "de") return de_style_guide_manager_enable_guide_aria(inputs)
	if (locale === "it") return it_style_guide_manager_enable_guide_aria(inputs)
	if (locale === "ru") return ru_style_guide_manager_enable_guide_aria(inputs)
	if (locale === "es") return es_style_guide_manager_enable_guide_aria(inputs)
	if (locale === "zh-CN") return zh_cn2_style_guide_manager_enable_guide_aria(inputs)
	if (locale === "ja") return ja_style_guide_manager_enable_guide_aria(inputs)
	if (locale === "hi") return hi_style_guide_manager_enable_guide_aria(inputs)
	if (locale === "pt-PT") return pt_pt2_style_guide_manager_enable_guide_aria(inputs)
	return en_style_guide_manager_enable_guide_aria(inputs)
});